import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

const HashTags = () => {
  const data = useStaticQuery(graphql`
    {
      allSanityTag {
        nodes {
          title
          slug {
            current
          }
          id
        }
      }
    }
  `)
  return (
    <div className="mt-5 bg-fb-turquoise h-80">
      <div className="relative" style={{ height: "60px" }}>
        <CategoryBar className="bg-fb-blue rounded-none md:rounded flex items-center pl-5 font-opensanscond category-bar inherit md:absolute">
          Все тэги
        </CategoryBar>
      </div>
      <div className="p-5 h-auto flex flex-wrap">
        {data.allSanityTag.nodes.map(tag => (
          <Link key={tag.id} to={`/tags/${tag.slug.current}`}>
            <p className="bg-transparent hover:bg-white text-white hover:text-fb-turquoise text-base font-semibold font-opensanscond py-2 px-4 rounded-full">
              {`#${tag.title}`}
            </p>
          </Link>
        ))}
      </div>
    </div>
  )
}

const CategoryBar = styled.div`
  bottom: 0px;
  right: 5px;
  width: 100%;
  height: 60px;
`

export default HashTags
